import styled from "styled-components";
import { Flex, Box } from "@edricphan2022/uikit";

export const Wrapper = styled(Box)`
  width: 100%;
  background-color: #fffef6;
`;

export const HeaderBox = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  position: relative;
  z-index: 10;
`;

export const HeaderLeft = styled(Flex)`
  width: 100%;
`;

export const HeaderRight = styled(Flex)`
  width: auto;
`;

export const FixedContainer = styled.div<{ showMenu: boolean; height: number; changeBackground: boolean }>`
  position: fixed;
  top: ${({ showMenu, height }) => (showMenu ? 0 : `-${height}px`)};
  left: 0;
  transition: top 0.2s;
  height: ${({ height }) => `${height}px`};
  width: 100%;
  z-index: 20;
  background: ${({ changeBackground }) => (changeBackground ? "rgba(241, 241, 242, 0.9)" : "")};
`;

export const BoxHeaderMobile = styled.div<{ isMenuMobile: boolean }>`
  width: 100%;
  height: ${({ isMenuMobile }) => (isMenuMobile ? `100%` : `0`)};
  visibility: ${({ isMenuMobile }) => (isMenuMobile ? `visible` : `hidden`)};
  opacity: ${({ isMenuMobile }) => (isMenuMobile ? `1` : `0`)};
  top: 0;
  left: 0;
  background: #FEFDF5;
  backdrop-filter: blur(30px);
  z-index: 30;
  position: fixed;
  transition: 0.3s ease;
`;
